export default class PeriodoDisponibilidadeEnum {
    static Manha = 1
    static Tarde = 2
    static Noite = 3
}
